<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.LIST-MEMBERS.selectMembersToCall' | translate }}
</h1>

<div mat-dialog-content>
  <ngx-members [membersSelected]="membersToCall" [hideLoged]="true" [showChecks]="true"></ngx-members>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="chat-input__button"
    color="primary"
    (click)="callMembers()"
    [disabled]="!membersToCall.length">
    {{ 'NGX-MESSAGING.LIST-MEMBERS.callMembers' | translate }}
  </button>
</div>
